import script from "./DemoVideoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DemoVideoModal.vue?vue&type=script&setup=true&lang=js"

import "./DemoVideoModal.vue?vue&type=style&index=0&id=c9435506&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9435506"]])

export default __exports__